import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionLabel } from './SectionLabel';
const perks = [{
  icon: MailIcon,
  label: 'Acceso inmediato por email'
}, {
  icon: DownloadIcon,
  label: 'PDF para celular, tablet o PC'
}, {
  icon: InfinityIcon,
  label: 'Un solo pago, para siempre'
}];
export function Pricing() {
  return <section id="precio" className="w-full scroll-mt-8 bg-cream paper-grain" data-id="element-111" data-mp="1vubmalpbab5g">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 text-center sm:px-6 sm:py-16 lg:py-24" data-id="element-112" data-mp="1rtrpxkckbbkd">
        <div className="flex justify-center" data-id="element-113" data-mp="25t0tnkjl0d7g">
          <SectionLabel data-id="element-114" data-mp="25pv6wbyfdnew">Precio irresistible</SectionLabel>
        </div>

        <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-115" data-mp="20rtl3j9m79zq">
          No vas a pagar $43.500
        </h2>
        <p className="mx-auto mt-4 max-w-lg font-sans text-[15px] leading-relaxed text-ink/65 sm:text-base" data-id="element-116" data-mp="3c8a4fnoaiarv">
          Queremos que el bienestar natural sea accesible para todas.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto mt-8 max-w-xl rounded-[1.75rem] border border-clay/30 bg-white/70 px-5 py-8 shadow-soft sm:mt-10 sm:rounded-[2rem] sm:px-10 sm:py-10" data-id="element-117" data-mp="3w1tbe5j17jbx">
          <p className="font-sans text-[11px] uppercase tracking-[0.28em] text-clay" data-id="element-118" data-mp="3i81x6jucvb9v">
            Precio especial hoy
          </p>
          <p className="mt-4 font-display text-[3.25rem] font-semibold leading-none text-ink sm:text-7xl" data-id="element-119" data-mp="3n6vb2ddk14ak">
            $19.990
            <span className="ml-2 align-middle font-sans text-base font-normal uppercase tracking-[0.14em] text-ink/50 sm:text-lg" data-id="element-120" data-mp="3rzeq7erw47hh">
              ARS
            </span>
          </p>
          <p className="mt-3 font-sans text-sm text-ink/50 line-through" data-id="element-121" data-mp="2zgiwijnt09b0">
            Valor real del pack: $43.500 ARS
          </p>

          <ul className="mt-7 grid gap-2.5 text-left sm:mt-8 sm:grid-cols-3 sm:gap-4" data-id="element-122" data-mp="2res0w4ik4swv">
            {perks.map(perk => <li key={perk.label} className="flex items-center gap-3 rounded-xl border border-ink/10 bg-cream/70 px-4 py-3 sm:flex-col sm:items-start sm:gap-2" data-id="element-123" data-mp="316o9wam6m3fv">
                <perk.icon className="h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-124" data-mp="28hqs08lvu8nn" />
                <span className="font-sans text-xs leading-snug text-ink/70" data-id="element-125" data-mp="23k7e59t3jxw8">
                  {perk.label}
                </span>
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-126" data-mp="2dgtxtv9osiwo">
            <CtaButton note="Pago único · Sin suscripciones" data-id="element-127" data-mp="2dfsbgun809zn" />
          </div>
        </motion.div>
      </div>
    </section>;
}